import { Component } from '@angular/core';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoService } from '../../../../services/rodeo.service';
import { AlertMessager } from '../../../../lib/alertMessager';

@Component({
    selector: 'page-new-publish',
    templateUrl: 'publish-prompt.html'
})
export class PublishPromptPage {
    rodeo: Rodeo;
    rodeoEvent: any;
    schedule: any;
    publish: boolean;
    stockPublish: boolean;

    allSchedules: any[];
    runPublishMessage: string;
    stockPublishMessage: string;

    popoverActive: boolean;

    constructor(private viewController: ViewController, private navParams: NavParams, private loadingControl: LoadingController,
        private rodeoService: RodeoService, private alert: AlertMessager, private toast: ToastController) {
        this.rodeo = this.navParams.get('rodeo');
        this.rodeoEvent = this.navParams.get('rodeoEvent');
        this.schedule = this.navParams.get('schedule');
        this.publish = this.navParams.get('publish');

        this.allSchedules = [];
        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.schedules.forEach((schedule) => {
                if (!this.allSchedules.find(x => x.name.toLowerCase().trim() == schedule.name.toLowerCase().trim()))
                    this.allSchedules.push((schedule));
            })
        })

        this.updatePublishStatuses();
    }

    updateClassSelection() {
        if (this.rodeoEvent != 'All' && this.schedule != 'All') {
            const matchingSchedule = this.rodeoEvent.schedules.find(x => x.name == this.schedule.name)

            if (!matchingSchedule)
                this.schedule = 'All';
            else
                this.schedule = matchingSchedule;
        }

        this.updatePublishStatuses();
    }

    updateScheduleSelection() {
        this.updatePublishStatuses();
    }

    updatePublishStatuses() {
        if (this.rodeoEvent == 'All') {
            if (this.schedule == 'All') {
                this.runPublishMessage = this.rodeo.rodeoEvents.flatMap(x => x.schedules).find(x => !x.published) != undefined ? 'All runs NOT published' : 'All runs published';
                this.stockPublishMessage = this.rodeo.rodeoEvents.flatMap(x => x.schedules).find(x => !x.stockPublished) != undefined ? 'All stock NOT published' : 'All stock published';
            } else {
                this.runPublishMessage = this.rodeo.rodeoEvents.flatMap(x => x.schedules).filter(x => x.name == this.schedule.name).find(x => !x.published) != undefined ? `All ${this.schedule.name}'s runs NOT published` : `All ${this.schedule.name}'s runs published`;
                this.stockPublishMessage = this.rodeo.rodeoEvents.flatMap(x => x.schedules).filter(x => x.name == this.schedule.name).find(x => !x.stockPublished) != undefined ? 'All stock NOT published' : `All ${this.schedule.name}.name's stock published`;
            }
        } else {
            if (this.schedule == 'All') {
                this.runPublishMessage = this.rodeoEvent.schedules.find(x => !x.published) != undefined ? `All ${this.rodeoEvent.displayName}'s runs NOT published` : `All ${this.rodeoEvent.displayName}'s runs published`;
                this.stockPublishMessage = this.rodeoEvent.schedules.find(x => !x.stockPublished) != undefined ? `All ${this.rodeoEvent.displayName}'s stock NOT published` : `All ${this.rodeoEvent.displayName}'s stock published`;
            } else {
                this.runPublishMessage = this.rodeoEvent.schedules.find(x => x.name == this.schedule.name && !x.published) != undefined ? `All ${this.schedule.name}'s runs for ${this.rodeoEvent.displayName} NOT published` : `All ${this.schedule.name}'s runs for ${this.rodeoEvent.displayName} published`;
                this.stockPublishMessage = this.rodeoEvent.schedules.find(x => x.name == this.schedule.name && !x.stockPublished) != undefined ? 'All stock NOT published' : `All ${this.schedule.name}'s stock for ${this.rodeoEvent.displayName} published`;
            }
        }
    }

    publishRuns() {
        const rodeoEventId = this.rodeoEvent == 'All' ? null : this.rodeoEvent.id;
        const scheduleId = this.schedule == 'All' ? null : this.schedule.id;
        this.sendNotifications(rodeoEventId, scheduleId, this.stockPublish, true);
    }

    unpublishRuns() {
        const rodeoEventId = this.rodeoEvent == 'All' ? null : this.rodeoEvent.id;
        const scheduleId = this.schedule == 'All' ? null : this.schedule.id;
        this.sendNotifications(rodeoEventId, scheduleId, this.stockPublish, false);
    }

    sendNotifications(rodeoEventId: number, scheduleId: number, stockPublish: boolean, publish: boolean) {
        let loading = this.loadingControl.create({
            content: publish ? 'Notifying contestants...' : 'Unpublishing runs...',
        });

        var message = "Success! ";
        var publishMessage = publish ? 'published' : 'unpublished';
        var selectedRodeoEvent = this.rodeo.rodeoEvents.find(x => x.id == rodeoEventId);
        var selectedSchedule = this.rodeo.rodeoEvents.flatMap(x => x.schedules).find(x => x.id == scheduleId);

        if (selectedSchedule)
            message += " " + selectedSchedule.name + ` has been ${publishMessage} for `;
        else
            message += ` All schedules have been ${publishMessage} for `;

        if (selectedRodeoEvent)
            message += " " + selectedRodeoEvent.displayName;
        else
            message += " all classes!";

        loading.present();

        if (publish) {
            this.rodeoService.sendRunNotifications(this.rodeo.id, rodeoEventId, scheduleId, stockPublish)
            .then((data: any) => {
                loading.dismiss();
                this.popoverActive = false;

                if (data.hasOwnProperty('message')) {
                    this.alert.showError("Run Notification Error", data.message);
                } else {
                    this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
                        if (rodeoEventId && rodeoEvent.id != rodeoEventId)
                            return;

                        rodeoEvent.schedules.forEach((schedule) => {
                            if (scheduleId && schedule.name != selectedSchedule.name)
                                return;

                            schedule.published = true;

                            if (stockPublish)
                                schedule.stockPublished = true;
                        }) 
                    });

                    this.updatePublishStatuses();

                    this.toast.create({
                        message: message,
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                }
            }, error => {
                loading.dismiss();
                this.popoverActive = false;
                console.log("Run Notification Error: ", error)
            });
        } else {
            this.rodeoService.unpublish(this.rodeo.id, rodeoEventId, scheduleId, stockPublish)
            .then((data: any) => {
                loading.dismiss();
                this.popoverActive = false;

                if (data.hasOwnProperty('message')) {
                    this.alert.showError("Run Notification Error", data.message);
                } else {
                    this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
                        if (rodeoEventId && rodeoEvent.id != rodeoEventId)
                            return;

                        rodeoEvent.schedules.forEach((schedule) => {
                        if (scheduleId && schedule.name != selectedSchedule.name)
                            return;

                            schedule.published = false;

                            if (stockPublish)
                                schedule.stockPublished = false;
                        }) 
                    });

                    this.toast.create({
                        message: message,
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                }
            }, error => {
                loading.dismiss();
                this.popoverActive = false;
                console.log("Run Notification Error: ", error)
            });
        }
    }

    selectOption(data) {
        this.viewController.dismiss(data);
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/publish-prompt.ts